export const AR = {
    header: 'الياسمين',
    title: 'للأعمال الهندسية والتشطيبات والديكور',
    btn: 'تواصل معنا',
}

export const USA = {
    header: 'Al-yasmeen',
    title: 'For engineering, finishing and decoration works',
    btn: 'Contact Us',
}